import styled, { css } from 'styled-components';

const erroredStyles = ({ hasError }) =>
  !!hasError &&
  css`
    .UncontrolledInput_input {
      box-shadow: 0 0 0 1px var(--error900);
      background-color: var(--error100);
    }
  `;

const styles = css`
  .UncontrolledInput_input {
    width: 100%;
    background-color: white;
    color: var(--grey900);
    border: 0;
    box-shadow: 0 0 0 1px var(--grey500);
    padding: 8px;
    height: 32px;
    border-radius: none;
    outline: none;
    &:focus {
      box-shadow: 0 0 0 2px var(--primary);
    }
  }

  .UncontrolledInput_textarea {
    height: auto;
    resize: none;
  }

  ${erroredStyles}
`;

const UncontrolledInput = ({ className, ...props }) => {
  return (
    <div className={className}>
      <input className="UncontrolledInput_input" {...props} />
    </div>
  );
};

const _UncontrolledTextarea_ = ({ className, ...props }) => {
  return (
    <div className={className}>
      <textarea className="UncontrolledInput_input UncontrolledInput_textarea" {...props} />
    </div>
  );
};

export default styled(UncontrolledInput)`
  ${styles}
`;

export const UncontrolledTextarea = styled(_UncontrolledTextarea_)`
  ${styles}
`;
